import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ArrowUpRightSquareContained = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M8.04687 7.2981H12.7344M12.7344 7.2981V11.9856M12.7344 7.2981L7.65625 12.3763M14.6875 17.5L5.31248 17.5C3.75919 17.5 2.5 16.2408 2.5 14.6875L2.5 5.3125C2.5 3.7592 3.75919 2.5 5.31248 2.5L14.6875 2.5C16.2408 2.5 17.5 3.7592 17.5 5.3125V14.6875C17.5 16.2408 16.2408 17.5 14.6875 17.5Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default ArrowUpRightSquareContained
